import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestResponse } from '../../shared/model/rest-response';
import { ValueField } from '../../settings/model/value-field';
import { RestSimpleRequest } from '../../shared/model/rest-simple-request';
import { RestDataLoader } from '../../shared/util/rest-data-loader';

@Injectable()
export class VehiclePropertiesService extends RestDataLoader<ValueField> {

  protected fetchRequest(_payload: any): Observable<RestResponse<ValueField>> {
    return this.sendFetchRequest();
  }

  sendFetchRequest(): Observable<RestResponse<ValueField>> {
    return this.postRequest<ValueField>(ValueField, 'api/fields/vehicleProperties/fetch');
  }

  updateProperty(values: any): Observable<any> {
    const payload: RestSimpleRequest = {
      data: {
        field_id: values.fieldId,
        name: values.name,
        type: values.type,
        field_name: values.fieldName,
        visible: values.visible
      }
    };
    return this.doPut<any>('api/admin/fields/vehicleProperties/update', payload);
  }

  removeProperty(id: number): Observable<any> {
    const payload: RestSimpleRequest = { data: { field_id: id } };
    return this.doPost<any>('api/admin/fields/vehicleProperties/remove', payload);
  }

}
